import { useEffect, useState } from 'react';
import { themes } from '../lib/theme';
import { jwtDecode } from 'jwt-decode';

const useTheme = () => {
  const [theme, setTheme] = useState(null);

  useEffect(() => {
    // const getTenant = () => {
    //   const token = sessionStorage.getItem("authToken");
    //   if (token) {
    //     const decodedToken = jwtDecode(token);
    //     return decodedToken.TenantName.toLowerCase();
    //   }
    //   return window.DEFAULT_THEME.toLowerCase();
    // };

    const getTenant = () => {
      // First try to get from session storage
      // const tenantName = sessionStorage.getItem("tenantName");
      // if (tenantName) {
      //   return tenantName.toLowerCase();
      // }

      // Then try JWT token
      const token = sessionStorage.getItem("authToken");
      if (token) {
        try {
          const decodedToken = jwtDecode(token);
          return decodedToken.TenantName.toLowerCase();
        } catch (error) {
          console.warn('Error decoding token:', error);
        }
      }

      // Fallback to default theme from window
      return window.DEFAULT_THEME.toLowerCase();
    };

    const tenant = getTenant();
    console.log("tenant ---", tenant);
    const currentTheme = themes[tenant] || themes[window.DEFAULT_THEME.toLowerCase()];
    setTheme(currentTheme);

    const logoElement = document.getElementById('logo');
    if (logoElement && currentTheme.logo) {
      logoElement.src = currentTheme.logo;
    }

    // Set favicon
    const faviconElement = document.getElementById('favicon');
    if (faviconElement) {
      const faviconUrl = currentTheme.favicon || currentTheme.logo; // Fallback to logo if favicon not specified
      if (faviconUrl) {
        faviconElement.href = faviconUrl;
        // Also set different sizes for better device support
        const sizes = ['16x16', '32x32', '192x192', '512x512'];
        sizes.forEach(size => {
          const link = document.createElement('link');
          link.rel = 'icon';
          link.sizes = size;
          link.href = faviconUrl;
          document.head.appendChild(link);
        });
      }
    }

    document.documentElement.style.setProperty('--primary-color', currentTheme.primaryButtonBgColor);
    document.documentElement.style.setProperty('--secondary-color', currentTheme.secondaryButtonBgColor);
    document.documentElement.style.setProperty('--text-color', currentTheme.textColor);
    document.documentElement.style.setProperty('--background-color', currentTheme.backgroundColor);
    document.documentElement.style.setProperty('--nav-background-color', currentTheme.navBackgroundColor);
    document.documentElement.style.setProperty('--nav-text-color', currentTheme.navTextColor);
    document.documentElement.style.setProperty('--label-color', currentTheme.labelColor);
    
    document.documentElement.style.setProperty('--primary-button-text-color', currentTheme.primaryButtonTextColor);
    document.documentElement.style.setProperty('--secondary-button-bg-color', currentTheme.secondaryButtonBgColor);
  }, []);

  return theme;
};

export default useTheme;